module.exports = __webpack_public_path__ + "resources/img/main_banner_cloud04_m.30929f9a2e92181f19b95ab4911f245f.png";